// src/components/common/Card.jsx
export const Card = ({ 
  children, 
  hover = false,
  padding = "24px",
  style = {},
  ...props 
}) => {
  const baseStyle = {
    backgroundColor: "white",
    borderRadius: "12px",
    padding,
    border: "1px solid #e2e8f0",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease"
  };

  const hoverStyle = hover ? {
    transform: "translateY(-4px)",
    boxShadow: "0 12px 24px rgba(0, 0, 0, 0.1)"
  } : {};

  return (
    <div
      style={{ ...baseStyle, ...style }}
      onMouseEnter={(e) => {
        if (hover) Object.assign(e.currentTarget.style, hoverStyle);
      }}
      onMouseLeave={(e) => {
        if (hover) {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
        }
      }}
      {...props}
    >
      {children}
    </div>
  );
};